import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const Breadcrumb = ({ pageKey, testId = "page-breadcrumb" }) => {
  const { t } = useLanguage();
  return (
    <nav data-testid={testId} className="text-xs sm:text-sm">
      <ol className="flex items-center gap-2 text-[color:var(--adhd-muted)]">
        <li>
          <Link to="/" className="hover:text-[color:var(--adhd-primary)]">
            {t("nav.home")}
          </Link>
        </li>
        <li>/</li>
        <li className="text-[color:var(--adhd-text)] font-medium">{t(pageKey)}</li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
